// AIHubPage — AI bot, bot config, marketplace, calculator, backtest

import { HubLayout } from './HubLayout';

export function AIHubPage() {
  return (
    <HubLayout
      title="AI & Personalization"
      testIdRoot="hub-ai"
      hero={{
        title: 'Your AI bot',
        subtitle: 'Strategies, automation, tools',
        emoji: '🤖',
        gradient: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)',
        stats: [
          { label: 'Status',  value: '● Live', sub: 'NQ strategy', color: '#34C759' },
          { label: 'P&L',     value: '+$842', sub: 'this week',   color: '#34C759' },
          { label: 'Win rate',value: '62%',   sub: '30d avg' },
        ],
      }}
      quickActions={[
        { to: '/portal/bot',            label: 'AI Bot',        icon: '🤖', testId: 'hub-ai-qa-bot' },
        { to: '/portal/bot-config',     label: 'Configure',     icon: '⚙️', testId: 'hub-ai-qa-config' },
        { to: '/portal/bot-marketplace',label: 'Marketplace',   icon: '🛒', testId: 'hub-ai-qa-market' },
      ]}
      sections={[
        {
          title: 'AI Trading Bot',
          items: [
            { to: '/portal/bot',             icon: '🤖', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'AI bot dashboard', sub: 'Live status, P&L, positions',     badge: { text: 'Running', color: 'white', bg: '#34C759' } },
            { to: '/portal/bot-config',      icon: '⚙️', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'Bot configuration', sub: 'Strategy, risk %, max DD' },
            { to: '/portal/bot-marketplace', icon: '🛒', iconBg: 'linear-gradient(135deg, #FF3B30 0%, #FF9500 100%)', label: 'Bot marketplace',    sub: '8 community strategies' },
            { to: '/portal/bot-detail/nq-momentum', icon: '📈', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Active strategy', sub: 'NQ momentum · +$842 / 7d' },
            { to: '/portal/strategies',      icon: '📜', iconBg: 'linear-gradient(135deg, #FF2D55 0%, #5856D6 100%)', label: 'All strategies',    sub: 'Browse + subscribe' },
          ],
        },
        {
          title: 'Trading Tools',
          items: [
            { to: '/portal/calculator',      icon: '🧮', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Position calculator', sub: 'Risk & contract size' },
            { to: '/portal/backtest',        icon: '🧪', iconBg: 'linear-gradient(135deg, #FF2D55 0%, #5856D6 100%)', label: 'Backtest lab',         sub: 'Test strategies on historical data', badge: { text: 'Pro', color: 'white', bg: '#1C1C1E' } },
            { to: '/portal/chart',           icon: '📊', iconBg: 'linear-gradient(135deg, #1C1C1E 0%, #48484A 100%)', label: 'Advanced chart',       sub: 'TV-style candlesticks' },
            { to: '/portal/trading-room',    icon: '🏛️', iconBg: 'linear-gradient(135deg, #FF3B30 0%, #B82B22 100%)', label: 'Trading room',         sub: 'Live signals + chat' },
          ],
        },
        {
          title: 'Personalization',
          items: [
            { to: '/portal/notifications-settings', icon: '🔔', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Notification preferences', sub: 'Channels, frequency, mute' },
            { to: '/portal/country',              icon: '🌍', iconBg: 'linear-gradient(135deg, #007AFF 0%, #5856D6 100%)', label: 'Region',                  sub: 'Affects tax + currency' },
            { to: '/portal/search',               icon: '🔍', iconBg: 'linear-gradient(135deg, #8E8E93 0%, #48484A 100%)', label: 'Universal search',         sub: 'Trades, traders, content' },
          ],
        },
      ]}
    />
  );
}
